import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	Output
} from '@angular/core';
import { SNModalService } from '@web-services/modal/snModal.service';
import { AdminUsersDataService } from '@web-services/admin/users/admin-users.data.service';
import { SubscriptionInfoModal } from '@web-components/admin/subscription-info/subscription-info-modal/subscription-info-modal';
import { Subject } from 'rxjs/Subject';
import { finalize, takeUntil } from 'rxjs/operators';
import { SubscriptionInfoStatus } from '@models/subscription.model';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'subscription-info-btn',
	template: require('./subscription-info-btn.html'),
	styles: [require('./subscription-info-btn.scss')]
})
export class SubscriptionInfoBtn implements OnDestroy {
	@Input('user') user;
	@Output('isDisabled') isDisabled: EventEmitter<boolean> = new EventEmitter();

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private modalService: SNModalService,
		private adminUsersDataService: AdminUsersDataService,
		private messageService: MessageService
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	showSubscriptionInfoModal(): void {
		this.isDisabled.emit(true);
		this.adminUsersDataService
			.getSubscriptionInfo(this.user)
			.pipe(
				takeUntil(this.unsubscribe),
				finalize((): void => {
					this.isDisabled.emit(false);
				})
			)
			.subscribe(
				({ data }): void => {
					this.successGetSubscriptionInfo(data);
				},
				(error): void => this.messageService.handleError(error)
			);
	}

	private successGetSubscriptionInfo(data: SubscriptionInfoStatus): void {
		const currentPlan = Object.keys(data.currentPlan.properties);
		const customerInfo = Object.keys(data.customerInfo.properties);
		const newPlan = data.newPlan ? Object.keys(data.newPlan.properties) : [];

		const modalRef = this.modalService.openModal(SubscriptionInfoModal, {
			windowClass: 'ng-bootstrap-modal'
		});

		modalRef.componentInstance.subscriptionInfo = data;
		modalRef.componentInstance.currentPlan = currentPlan;
		modalRef.componentInstance.customerInfo = customerInfo;
		modalRef.componentInstance.newPlan = newPlan;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/admin/subscription-info/subscription-info-btn.ts